import { useInfiniteQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from "../../Context/AuthContext";

const fetchShippingCost = async ({ pageParam = 1 }, token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/shipping/get-all-cost?page=${pageParam}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch shipping cost');
  }

  return response.json();
};

const useFetchShippingCost = () => {
  const { token } = useContext(AuthContext);

  return useInfiniteQuery(
    ['shippingCost'], 
    ({ pageParam = 1 }) => fetchShippingCost({ pageParam }, token),
    {
      getNextPageParam: (lastPage) => {
        const { currentPage, totalShippingCosts } = lastPage; 
        const totalPages = Math.ceil(totalShippingCosts / 10); 
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
    }
  );
};

export default useFetchShippingCost;








